// import React from "react";
// import { Grid, Typography, Button } from "@mui/material";

// const UploadWithLabel = ({ label, name, onChange, file }) => (
//   <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
//     <Grid item xs={6} md={2}>
//       <Typography>{label}</Typography>
//     </Grid>
//     <Grid item xs={6} md={4}>
//       <Button variant="outlined" component="label" fullWidth>
//         Upload File
//         <input type="file" hidden name={name} onChange={onChange} />
//       </Button>
//       {file && (
//         <Typography variant="caption" sx={{ mt: 0.5, display: "block", wordBreak: "break-all" }}>
//           {file.name}
//         </Typography>
//       )}
//     </Grid>
//   </Grid>
// );

// export default UploadWithLabel;


// import React, { useRef, useState } from "react";
// import { Box, Typography, Button } from "@mui/material";
// import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
// import CloseIcon from "@mui/icons-material/Close";

// const UploadWithLabel = ({ label, name, onChange, file, error, helperText, accept, disabled }) => {
//   const inputRef = useRef();
//   const [dragging, setDragging] = useState(false);

//   const handleDrop = (e) => {
//     e.preventDefault();
//     setDragging(false);
//     if (disabled) return;
//     const droppedFile = e.dataTransfer.files[0];
//     if (droppedFile && onChange) {
//       const syntheticEvent = { currentTarget: { files: [droppedFile] } };
//       onChange(syntheticEvent);
//     }
//   };

//   const handleClear = (e) => {
//     e.stopPropagation();
//     if (inputRef.current) inputRef.current.value = "";
//     if (onChange) {
//       const syntheticEvent = { currentTarget: { files: [null] } };
//       onChange(syntheticEvent);
//     }
//   };

//   const uploaded = !!file;

//   return (
//     <Box sx={{ width: "100%" }}>
//       <Typography
//         variant="caption"
//         sx={{
//           display: "block",
//           mb: 0.75,
//           fontWeight: 600,
//           fontSize: "0.78rem",
//           color: error ? "#d32f2f" : "#5a6a85",
//           letterSpacing: "0.04em",
//           textTransform: "uppercase",
//           fontFamily: "'DM Sans', sans-serif",
//         }}
//       >
//         {label}
//       </Typography>

//       <Box
//         onClick={() => !disabled && inputRef.current?.click()}
//         onDragOver={(e) => { e.preventDefault(); if (!disabled) setDragging(true); }}
//         onDragLeave={() => setDragging(false)}
//         onDrop={handleDrop}
//         sx={{
//           position: "relative",
//           border: uploaded
//             ? "2px solid #10b981"
//             : error
//             ? "2px solid #ef4444"
//             : dragging
//             ? "2px solid #3b82f6"
//             : "2px dashed #cbd5e1",
//           borderRadius: "14px",
//           background: uploaded
//             ? "linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%)"
//             : dragging
//             ? "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)"
//             : error
//             ? "linear-gradient(135deg, #fff5f5 0%, #fee2e2 100%)"
//             : "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
//           p: "18px 20px",
//           cursor: disabled ? "not-allowed" : "pointer",
//           transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
//           display: "flex",
//           alignItems: "center",
//           gap: 2,
//           "&:hover": !disabled ? {
//             borderColor: uploaded ? "#10b981" : "#3b82f6",
//             background: uploaded
//               ? "linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)"
//               : "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
//             transform: "translateY(-1px)",
//             boxShadow: uploaded
//               ? "0 4px 20px rgba(16,185,129,0.15)"
//               : "0 4px 20px rgba(59,130,246,0.15)",
//           } : {},
//           opacity: disabled ? 0.6 : 1,
//         }}
//       >
//         <input
//           ref={inputRef}
//           type="file"
//           hidden
//           name={name}
//           onChange={onChange}
//           accept={accept || ".pdf,application/pdf"}
//           disabled={disabled}
//         />

//         {/* Icon */}
//         <Box
//           sx={{
//             width: 44,
//             height: 44,
//             borderRadius: "12px",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             flexShrink: 0,
//             background: uploaded
//               ? "linear-gradient(135deg, #10b981, #059669)"
//               : error
//               ? "linear-gradient(135deg, #ef4444, #dc2626)"
//               : "linear-gradient(135deg, #3b82f6, #2563eb)",
//             boxShadow: uploaded
//               ? "0 4px 12px rgba(16,185,129,0.35)"
//               : error
//               ? "0 4px 12px rgba(239,68,68,0.35)"
//               : "0 4px 12px rgba(59,130,246,0.35)",
//           }}
//         >
//           {uploaded ? (
//             <CheckCircleIcon sx={{ color: "#fff", fontSize: 22 }} />
//           ) : (
//             <CloudUploadIcon sx={{ color: "#fff", fontSize: 22 }} />
//           )}
//         </Box>

//         {/* Text */}
//         <Box sx={{ flex: 1, minWidth: 0 }}>
//           {uploaded ? (
//             <>
//               <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//                 <InsertDriveFileIcon sx={{ fontSize: 14, color: "#10b981" }} />
//                 <Typography
//                   sx={{
//                     fontWeight: 700,
//                     fontSize: "0.82rem",
//                     color: "#065f46",
//                     fontFamily: "'DM Sans', sans-serif",
//                     whiteSpace: "nowrap",
//                     overflow: "hidden",
//                     textOverflow: "ellipsis",
//                   }}
//                 >
//                   {file.name}
//                 </Typography>
//               </Box>
//               <Typography sx={{ fontSize: "0.72rem", color: "#6ee7b7", fontWeight: 500, mt: 0.2 }}>
//                 {(file.size / 1024).toFixed(1)} KB · PDF
//               </Typography>
//             </>
//           ) : (
//             <>
//               <Typography sx={{ fontWeight: 700, fontSize: "0.84rem", color: error ? "#b91c1c" : "#334155", fontFamily: "'DM Sans', sans-serif" }}>
//                 {dragging ? "Drop it here!" : "Click or drag & drop"}
//               </Typography>
//               <Typography sx={{ fontSize: "0.72rem", color: "#94a3b8", mt: 0.2 }}>
//                 PDF only · Max 2MB
//               </Typography>
//             </>
//           )}
//         </Box>

//         {/* Clear button */}
//         {uploaded && (
//           <Box
//             onClick={handleClear}
//             sx={{
//               width: 28,
//               height: 28,
//               borderRadius: "50%",
//               background: "rgba(0,0,0,0.08)",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               flexShrink: 0,
//               "&:hover": { background: "rgba(239,68,68,0.15)" },
//               transition: "background 0.2s",
//             }}
//           >
//             <CloseIcon sx={{ fontSize: 14, color: "#475569" }} />
//           </Box>
//         )}

//         {/* Change badge */}
//         {uploaded && (
//           <Box
//             sx={{
//               position: "absolute",
//               top: -1,
//               right: -1,
//               background: "linear-gradient(135deg, #3b82f6, #2563eb)",
//               color: "#fff",
//               fontSize: "0.65rem",
//               fontWeight: 700,
//               px: 1,
//               py: 0.3,
//               borderRadius: "0 12px 0 8px",
//               letterSpacing: "0.05em",
//               textTransform: "uppercase",
//             }}
//           >
//             Change
//           </Box>
//         )}
//       </Box>

//       {helperText && (
//         <Typography
//           sx={{
//             mt: 0.5,
//             fontSize: "0.72rem",
//             color: error ? "#d32f2f" : "#64748b",
//             fontFamily: "'DM Sans', sans-serif",
//             ml: 1,
//           }}
//         >
//           {helperText}
//         </Typography>
//       )}
//     </Box>
//   );
// };

// export default UploadWithLabel;



import React, { useRef, useState } from "react";
import { Box, Typography } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import CloseIcon from "@mui/icons-material/Close";

const UploadWithLabel = ({ label, name, onChange, file, error, helperText, accept, disabled, isImage }) => {
  const inputRef = useRef();
  const [dragging, setDragging] = useState(false);

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    if (disabled) return;
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile && onChange) {
      const syntheticEvent = { currentTarget: { files: [droppedFile] } };
      onChange(syntheticEvent);
    }
  };

  const handleClear = (e) => {
    e.stopPropagation();
    if (inputRef.current) inputRef.current.value = "";
    if (onChange) {
      const syntheticEvent = { currentTarget: { files: [null] } };
      onChange(syntheticEvent);
    }
  };

  const uploaded = !!file;

  return (
    <Box sx={{ width: "100%" }}>
      <Typography
        variant="caption"
        sx={{
          display: "block",
          mb: 0.75,
          fontWeight: 600,
          fontSize: "0.78rem",
          color: error ? "#d32f2f" : "#5a6a85",
          letterSpacing: "0.04em",
          textTransform: "uppercase",
          fontFamily: "'DM Sans', sans-serif",
        }}
      >
        {label}
      </Typography>

      <Box
        onClick={() => !disabled && inputRef.current?.click()}
        onDragOver={(e) => { e.preventDefault(); if (!disabled) setDragging(true); }}
        onDragLeave={() => setDragging(false)}
        onDrop={handleDrop}
        sx={{
          position: "relative",
          border: uploaded
            ? "2px solid #10b981"
            : error
            ? "2px solid #ef4444"
            : dragging
            ? "2px solid #3b82f6"
            : "2px dashed #cbd5e1",
          borderRadius: "14px",
          background: uploaded
            ? "linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%)"
            : dragging
            ? "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)"
            : error
            ? "linear-gradient(135deg, #fff5f5 0%, #fee2e2 100%)"
            : "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
          p: "18px 20px",
          cursor: disabled ? "not-allowed" : "pointer",
          transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
          display: "flex",
          alignItems: "center",
          gap: 2,
          "&:hover": !disabled ? {
            borderColor: uploaded ? "#10b981" : "#3b82f6",
            background: uploaded
              ? "linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)"
              : "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
            transform: "translateY(-1px)",
            boxShadow: uploaded
              ? "0 4px 20px rgba(16,185,129,0.15)"
              : "0 4px 20px rgba(59,130,246,0.15)",
          } : {},
          opacity: disabled ? 0.6 : 1,
        }}
      >
        <input
          ref={inputRef}
          type="file"
          hidden
          name={name}
          onChange={onChange}
          accept={accept || (isImage ? "image/jpeg,image/jpg,image/png" : ".pdf,application/pdf")}
          disabled={disabled}
        />

        {/* Icon */}
        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            background: uploaded
              ? "linear-gradient(135deg, #10b981, #059669)"
              : error
              ? "linear-gradient(135deg, #ef4444, #dc2626)"
              : "linear-gradient(135deg, #3b82f6, #2563eb)",
            boxShadow: uploaded
              ? "0 4px 12px rgba(16,185,129,0.35)"
              : error
              ? "0 4px 12px rgba(239,68,68,0.35)"
              : "0 4px 12px rgba(59,130,246,0.35)",
          }}
        >
          {uploaded ? (
            <CheckCircleIcon sx={{ color: "#fff", fontSize: 22 }} />
          ) : (
            <CloudUploadIcon sx={{ color: "#fff", fontSize: 22 }} />
          )}
        </Box>

        {/* Text */}
        <Box sx={{ flex: 1, minWidth: 0 }}>
          {uploaded ? (
            <>
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <InsertDriveFileIcon sx={{ fontSize: 14, color: "#10b981" }} />
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "0.82rem",
                    color: "#065f46",
                    fontFamily: "'DM Sans', sans-serif",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {file.name}
                </Typography>
              </Box>
              <Typography sx={{ fontSize: "0.72rem", color: "#6ee7b7", fontWeight: 500, mt: 0.2 }}>
                {(file.size / 1024).toFixed(1)} KB · {isImage ? file.type.split("/")[1].toUpperCase() : "PDF"}
              </Typography>
            </>
          ) : (
            <>
              <Typography sx={{ fontWeight: 700, fontSize: "0.84rem", color: error ? "#b91c1c" : "#334155", fontFamily: "'DM Sans', sans-serif" }}>
                {dragging ? "Drop it here!" : "Click or drag & drop"}
              </Typography>
              <Typography sx={{ fontSize: "0.72rem", color: "#94a3b8", mt: 0.2 }}>
                {isImage ? "JPG, JPEG, PNG only · Max 2MB" : "PDF only · Max 2MB"}
              </Typography>
            </>
          )}
        </Box>

        {/* Clear button */}
        {uploaded && (
          <Box
            onClick={handleClear}
            sx={{
              width: 28,
              height: 28,
              borderRadius: "50%",
              background: "rgba(0,0,0,0.08)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              "&:hover": { background: "rgba(239,68,68,0.15)" },
              transition: "background 0.2s",
            }}
          >
            <CloseIcon sx={{ fontSize: 14, color: "#475569" }} />
          </Box>
        )}

        {/* Change badge */}
        {uploaded && (
          <Box
            sx={{
              position: "absolute",
              top: -1,
              right: -1,
              background: "linear-gradient(135deg, #3b82f6, #2563eb)",
              color: "#fff",
              fontSize: "0.65rem",
              fontWeight: 700,
              px: 1,
              py: 0.3,
              borderRadius: "0 12px 0 8px",
              letterSpacing: "0.05em",
              textTransform: "uppercase",
            }}
          >
            Change
          </Box>
        )}
      </Box>

      {helperText && !file && (
        <Typography
          sx={{
            mt: 0.5,
            fontSize: "0.72rem",
            color: error ? "#d32f2f" : "#64748b",
            fontFamily: "'DM Sans', sans-serif",
            ml: 1,
          }}
        >
          {helperText}
        </Typography>
      )}
    </Box>
  );
};

export default UploadWithLabel;